import { createContext } from 'react';
import { StandaloneCalendarContextProps } from './Calendar.types';

const StandaloneCalendarContext =
  // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  createContext<StandaloneCalendarContextProps>(undefined);

export default StandaloneCalendarContext;
